import { GeneralPropsType } from "@/common/types";
import styles from "./index.module.css";
import clsx from "clsx";
import { ReactElement, ReactNode } from "react";
interface TwoColumnProps extends GeneralPropsType {
  firstColumn?: ReactNode;
  secondColumn?: ReactNode;
  isDivider?: boolean;
  classNames?: {
    secondColumn?: string;
  };
}
function TwoColumn({
  className,
  firstColumn,
  secondColumn,
  isDivider,
  classNames
}: TwoColumnProps) {
  return <div className={clsx("flex items-stretch place-self-stretch gap-2", styles.container, className)} data-sentry-component="TwoColumn" data-sentry-source-file="index.tsx">
      <div className="flex-1 max-w-[50%] animate-fade-right animate-duration-1000">
        {firstColumn}
      </div>
      {isDivider && <div className=" w-px bg-description/[0.16] self-auto" />}
      <div className={clsx("flex-1 max-w-[50%] animate-fade-left animate-duration-1000", classNames?.secondColumn)}>
        {secondColumn}
      </div>
    </div>;
}
export default TwoColumn;